// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import {getFunctions} from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA6FjbVXri6OXRpl0zNgieyYmat-dwSc8I",
  authDomain: "nccs-registration.firebaseapp.com",
  projectId: "nccs-registration",
  storageBucket: "nccs-registration.appspot.com",
  messagingSenderId: "783992909245",
  appId: "1:783992909245:web:50acb9f53b0cde8c5b36d4",
  measurementId: "G-D9DY1FCQ8G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);


// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-west2");
export const auth = getAuth(app);
export const storage = getStorage(app);